import { render, staticRenderFns } from "./FaultEventAlarmBulkAction.vue?vue&type=template&id=b5f549a2"
import script from "./FaultEventAlarmBulkAction.vue?vue&type=script&lang=ts"
export * from "./FaultEventAlarmBulkAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports